/**
 * @generated SignedSource<<08efbeb0978c5964d114b0a05129b19a>>
 * @relayHash 7cbaaaa830114d2473b9895e28c7e252
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3dbfb7005d133e3115ee8635e9e6945c7a3d9a2c6cac8c6efb223bf6a2b9999a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueTypeFilterInput = {
  maxHierarchyLevel?: number | null | undefined;
  minHierarchyLevel?: number | null | undefined;
};
export type issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query$variables = {
  cursor?: string | null | undefined;
  filter?: JiraIssueTypeFilterInput | null | undefined;
  first?: number | null | undefined;
  id: string;
};
export type issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"IssueTypeDropdown">;
  } | null | undefined;
};
export type issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query = {
  response: issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query$data;
  variables: issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider: {
    readonly get: () => boolean;
  };
});

import isInlineManageWorkTypesConfigNinIccEnabled_provider from '@atlassian/jira-relay-provider/src/jira-nin-inline-manage-work-type-config.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v6 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "IssueTypeDropdown"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v9/*: any*/),
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "large"
                  }
                ]
              },
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "issueTypeId"
                          },
                          (v9/*: any*/),
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "small"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraIssueTypeHierarchyLevel",
                            "kind": "LinkedField",
                            "name": "hierarchy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "level"
                              }
                            ]
                          },
                          (v7/*: any*/),
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v10/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "inlineIssueCreate_IssueTable_issueTypes",
                "kind": "LinkedHandle",
                "name": "issueTypes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3dbfb7005d133e3115ee8635e9e6945c7a3d9a2c6cac8c6efb223bf6a2b9999a",
    "metadata": {},
    "name": "issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
    }
  }
};
})();

(node as any).hash = "97d846c1de1aa164712eb51b2bef4085";

export default node;
